import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import React from "react";
import {
  Box,
  ComponentMultiStyleConfig,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { ReplyCommentBlockItemContent } from "../types";
import { CMReplyCommentBlockItem } from "../CMReplyCommentBlockItem/CMReplyCommentBlockItem";

export type CMReplyCommentBlockProps = {
  /**
   * 表示用のデータ
   */
  contents: ReplyCommentBlockItemContent[];

  /**
   * ファイルが選択されたときに、そのファイルを引数として呼び出される。
   * @param fileId
   * @param fileName ファイル名
   */
  onDownloadFile?: (fileId: string, fileName: string) => void;
} & ComponentStyleProps;

/**
 * 送信者情報とメッセージ本文を複数件表示する。
 */
export const CMReplyCommentBlock = ({
  contents,
  onDownloadFile,

  sx,
  ...rest
}: CMReplyCommentBlockProps) => {
  const styles = useMultiStyleConfig("CMReplyCommentBlockStyles");

  return (
    <Box sx={{ ...styles.container, ...sx }} {...rest}>
      {/*返信の一覧*/}
      {contents.map((content, index) => (
        <Box key={index} sx={styles.mainArea}>
          {/*返信内容*/}
          <CMReplyCommentBlockItem
            content={content}
            onDownloadFile={onDownloadFile}
          />
        </Box>
      ))}
    </Box>
  );
};

export const CMReplyCommentBlockStyles: ComponentMultiStyleConfig = {
  parts: ["container", "mainArea"],
  baseStyle: {
    container: {},
    headerArea: {
      display: "flex",
      flexDirection: "row",
      color: "gray.500",
    },
    mainArea: {
      borderWidth: "1px",
      borderLeftStyle: "none",
      borderRightStyle: "none",
      borderColor: "transparent",
      borderTopColor: "gray.400",
      paddingTop: "20px",
      paddingBottom: "10px",
    },
  },
};
